import type { PropsWithChildren } from 'react'
import AccessDenied from '../../../components/AccessDenied'
import type { Permission } from './permissions'
import {
  useHasAllPermissions,
  useHasAnyPermission,
  useIsSuperAdmin,
} from './usePermissions'

interface PermissionProviderProps extends PropsWithChildren {
  permission: Permission | Permission[]
  gameId?: string
  requireAll?: boolean
  showAccessDenied?: boolean
}

export function PermissionProvider({
  permission,
  gameId,
  requireAll = false,
  showAccessDenied = false,
  children,
}: PermissionProviderProps) {
  const isSuperAdmin = useIsSuperAdmin()
  const hasAnyPermission = useHasAnyPermission(
    Array.isArray(permission) ? permission : [permission],
    gameId
  )
  const hasAllPermission = useHasAllPermissions(
    Array.isArray(permission) ? permission : [permission],
    gameId
  )

  if (isSuperAdmin) {
    return <>{children}</>
  }

  const hasRequiredPermission = requireAll ? hasAllPermission : hasAnyPermission

  if (!hasRequiredPermission) {
    if (showAccessDenied) {
      return <AccessDenied />
    }

    return null
  }

  return <>{children}</>
}
